<template>
    <div class="pt-4 tb-4">
        <div class="display-1">Числовая грамотность и счет</div>

        <v-layout>
            <v-flex v-if="!hideChart">
                <charts-pie :value="value" :max="500" :level="level"></charts-pie>
            </v-flex>
            <v-flex xs12 class="ml-4">
                <ul class="mt-4">
                    <li v-for="(t, i) in result.text" :key="i">{{t}}</li>
                </ul>
                <div class="title mt-3 mb-2">Рекомендации:</div>
                <p>{{result.recommendation}}</p>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
    import data from './data'
    import ChartsPie from '@/components/charts/pie'

    export default {
        props: {
            value: Number,
            hideChart: Boolean
        },
        components: {
            ChartsPie
        },
        computed: {
            level () {
                if (this.value > 376) {
                    return 5
                } else if (this.value > 326) {
                    return 4
                } else if (this.value > 276) {
                    return 3
                } else if (this.value > 226) {
                    return 2
                } else if (this.value > 176) {
                    return 1
                } else {
                    return 0
                }
            },
            result () {
                return data['level' + this.level]
            }
        }
    }
</script>
